<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['寄样管理']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" style="width: 100%" border class="flex-1" stripe height="100%">
            <el-table-column type="index" width="60px" align="center" label="序号" fixed=""> </el-table-column>
            <el-table-column label="类别" prop="sendSample" align="center" show-overflow-tooltip width="240px">
              <template slot-scope="scope">
                {{ getType(scope.row.sendSample) }}
              </template>
            </el-table-column>
            <el-table-column label="产品名" prop="productName" align="center" show-overflow-tooltip width="240px">
            </el-table-column>
            <el-table-column label="品牌名" prop="brandName" align="center" show-overflow-tooltip
              width="240px"></el-table-column>
            <el-table-column width="200px" label="用户标签" prop="userLevel" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                {{getUserLevel(scope.row.userLevel)}}
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="detail" align="center" show-overflow-tooltip
              width="240px"></el-table-column>
            <el-table-column label="申请时间" prop="createTime" align="center" show-overflow-tooltip width="200px"
              sortable></el-table-column>
            <el-table-column align="center" width="100" label="操作" fixed="right">
              <template v-slot="scope">
                <el-button icon="el-icon-document-checked" type="text" @click="goDetail(scope.row.id)"
                           size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
            :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      contacts: '',
      phone: '',
      companyName: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        contacts: this.contacts,
        phone: this.phone,
        companyName: this.companyName
      }
      let { data: res } = await this.$http.post(
        '/applySendSample/pageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      }
    },
    reset () {
      this.contacts = ''
      this.phone = ''
      this.companyName = ''
      this.currentPage = 1
      this.pageSize = 10
      this.getPageList()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    getType (val) {
      const sendSamples = [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ]
      const a = sendSamples.filter(item => item.id === val) || []
      return a[0].name || ''
    },
    getAddress (data) {
      const addressOne = data.addressOne || ''
      const addressTwo = data.addressTwo || ''
      const addressThree = data.addressThree || ''
      const address = data.address || ''
      return addressOne + addressTwo + addressThree + address
    },
    getUserLevel (level) {
      if (level === '5') return '专业买家'
      if (level === '7') return 'CBE展商'
      return ''
    },
    goDetail (id) {
      this.$router.push({
        name: 'SendingSamplesDetail',
        query: { id }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/SendingSamples/index.vue